export default "__VITE_ASSET__Cm9Rh1Yb__"